import {
  domScriptInjectAsync,
  NODE_ENV,
  REACT_APP__INTERCOM_APP_ID,
} from "@smp/utils";
import { Intercom } from "custom";
import { useRef, useState } from "react";
import { useEffectOnce } from "react-use";

export const useIntercom = (enabled: boolean) => {
  const initedListeners = useRef<Function[]>([]);
  const [isInited, setIsInited] = useState<boolean>(false);

  const hide = () => {
    if (window.Intercom) {
      window.Intercom("hide");
    } else {
      initedListeners.current.push(() => {
        window.Intercom && window.Intercom("hide");
      });
    }
  };

  const show = () => {
    if (window.Intercom) {
      window.Intercom("show");
    } else {
      initedListeners.current.push(() => {
        window.Intercom && window.Intercom("show");
      });
    }
  };

  const showNewMessage = (message: string) => {
    if (window.Intercom) {
      window.Intercom("showNewMessage", message);
    } else {
      initedListeners.current.push(() => {
        window.Intercom && window.Intercom("showNewMessage", message);
      });
    }
  };

  const update = (options: any) => {
    if (window.Intercom) {
      window.Intercom("update", options);
    } else {
      initedListeners.current.push(() => {
        window.Intercom && window.Intercom("update", options);
      });
    }
  };

  useEffectOnce(() => {
    (async () => {
      if (!REACT_APP__INTERCOM_APP_ID || !enabled || NODE_ENV === "development")
        return;

      if (window.Intercom) return setIsInited(true);

      await domScriptInjectAsync(
        "https://widget.intercom.io/widget/" + REACT_APP__INTERCOM_APP_ID,
      );

      const Intercom = window.Intercom as unknown as Intercom;

      Intercom("boot", {
        app_id: REACT_APP__INTERCOM_APP_ID,
        hide_default_launcher: true,
      });

      while (initedListeners.current.length) {
        const callback = initedListeners.current.shift();

        callback && callback();
      }

      setIsInited(true);
    })();
  });

  return {
    hide,
    isInited,
    show,
    showNewMessage,
    update,
  };
};
